import { InjectionToken } from '@angular/core';
import { Observable } from 'rxjs';
import { LocalUser } from '../models/local-user.model';
import { LocalUserCreateInput } from '../models/local-user-create-input.model';
import { LocalUserUpdateInput } from '../models/local-user-update-input.model';
import { UnlinkedVeterinaryUser } from '../models/unlinked-veterinary-user.model';

export interface CreateDeveloperClientInput {
  readonly departmentId: number;
  readonly username: string;
  readonly password: string;
  readonly firstName: string;
  readonly lastName: string;
}

export interface StaffRoster {
  readonly items: readonly LocalUser[];
  readonly unlinkedVeterinaryUsers: readonly UnlinkedVeterinaryUser[];
}

export interface ILocalUsersRepository {
  list(organizationId: number): Observable<readonly LocalUser[]>;
  getRoster(organizationId: number): Observable<StaffRoster>;
  create(organizationId: number, input: LocalUserCreateInput): Observable<LocalUser>;
  update(organizationId: number, id: number, input: LocalUserUpdateInput): Observable<LocalUser>;
  deactivate(organizationId: number, id: number): Observable<void>;
  deletePermanently(organizationId: number, id: number): Observable<void>;
  createDeveloperClient(organizationId: number, input: CreateDeveloperClientInput): Observable<void>;
  resendInvitation(organizationId: number, id: number): Observable<void>;
}

export const LOCAL_USERS_REPOSITORY = new InjectionToken<ILocalUsersRepository>('ILocalUsersRepository');
